module.exports = __webpack_public_path__ + "img/bg-3.412c241f.jpg";